import { QUICK_TOUR_VIDEO_TYPE } from "../../../api/videoApi";
import { useVideoByType } from "./useVideoByType";

export const useQuickTourVideo = () => useVideoByType(QUICK_TOUR_VIDEO_TYPE);
